import { z } from "zod";
/**
 * Time primitives for the payload contract.
 *
 * The worker triggers calls against absolute instants, so wake/hard-wake are
 * stored as ISO-8601 strings *with offset* (UTC or zoned). A separate IANA
 * timezone travels alongside for display ("6:45 AM") and for the brain to
 * recompute against. We never store a naive local time as an alarm anchor —
 * DST and travel make that a footgun.
 */
/** ISO-8601 instant with offset, e.g. "2026-06-17T10:45:00Z" or "...-04:00". */
export const Instant = z
    .string()
    .datetime({ offset: true })
    .describe("ISO-8601 instant with timezone offset");
/** Calendar date in the operator's local timezone, "YYYY-MM-DD". */
export const LocalDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "expected YYYY-MM-DD");
/** Wall-clock time of day, "HH:MM" 24h. Used for config defaults, not alarms. */
export const LocalTime = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, "expected HH:MM (24h)");
/** IANA timezone identifier, e.g. "America/New_York". */
export const Timezone = z.string().min(1).describe("IANA timezone id");
//# sourceMappingURL=time.js.map